module.exports = __webpack_public_path__ + "static/media/Nickainley-01.e9bd95f4.svg";